/**
 * Gets the time from the date object provided or undefined if it is null or invalid
 * @param date should be a date object or null
 * @returns {undefined|*} the time from the date or undefined
 */
export const getTimeFromDate = date => {
  if (date === null || (date instanceof Date && Number.isNaN(Number(date)))) {
    return undefined;
  } else {
    return date.getTime();
  }
};
